// Central image configuration.
// IMPORTANT: Only real project images are allowed here (no stock/AI/placeholder).
// Empty string => a neutral "image coming soon" placeholder block is shown (no stock photo).

const A = "https://customer-assets.emergentagent.com/job_sakuru-namai-lt/artifacts";

export const IMAGES = {
  // Exterior renders (real project renders)
  heroNight: `${A}/6egfzg7f_marijampoles-m-deguciai-parko-g%20%2810%29.jpg`, // night, gold-lit facade
  heroDay: `${A}/mqrdpk1t_marijampoles-m-deguciai-parko-g%20%287%29.jpg`,     // day, two buildings
  aerial: `${A}/pxbdn0j1_marijampoles-m-deguciai-parko-g%20%2811%29.jpg`,     // aerial, day
  parking: `${A}/pxbdn0j1_marijampoles-m-deguciai-parko-g%20%2811%29.jpg`,    // parking (aerial shows lot)
  courtyard: `${A}/moku8m7r_marijampoles-m-deguciai-parko-g%20%288%29.jpg`,   // playground / courtyard (night)
  exterior1: `${A}/mqrdpk1t_marijampoles-m-deguciai-parko-g%20%287%29.jpg`,   // day exterior
  exterior2: `${A}/6egfzg7f_marijampoles-m-deguciai-parko-g%20%2810%29.jpg`,  // night exterior
  exterior3: `${A}/moku8m7r_marijampoles-m-deguciai-parko-g%20%288%29.jpg`,   // courtyard night

  // 2nd batch of real renders
  vysniaDay: `${A}/47kcfdn9_unnamed.png`,        // daytime aerial (Vyšnia card)
  duskTwin: `${A}/zmv8rken_unnamed-12.png`,      // twin buildings at dusk
  duskWalkway: `${A}/8kd7ozmc_unnamed-11.png`,   // walkway between buildings (dusk)
  nightFacade2: `${A}/wh5quk2q_unnamed-13.png`,  // night facade corner
  nightAerial: `${A}/2f0jbqfg_unnamed-14.png`,   // night aerial w/ playground
  migdolasHero: "/migdolas-hero.jpg",            // Migdolas cover (Gemini watermark cropped)
  vysniaHero: "/vysnia-hero.jpg",                // Vyšnia cover render

  // Building floor plans (10 total: first 5 Migdolas, last 5 Vyšnia)
  migdolasFloors: [
    `${A}/7ew276hb_WhatsApp%20Image%202026-07-03%20at%2017.48.01%20%2822%29.jpeg`, // 1st floor (A01-A04)
    `${A}/wazbqzft_WhatsApp%20Image%202026-07-03%20at%2017.48.01%20%2823%29.jpeg`, // 2nd floor (A05-A08)
    `${A}/ato7l9yt_WhatsApp%20Image%202026-07-03%20at%2017.48.01%20%2824%29.jpeg`, // 3rd floor (A09-A12)
    `${A}/inefjx2r_WhatsApp%20Image%202026-07-03%20at%2017.48.01%20%2821%29.jpeg`, // 4th floor (A13-A16)
    `${A}/9shk8b5v_WhatsApp%20Image%202026-07-03%20at%2017.48.01%20%2820%29.jpeg`, // 5th floor (A17-A18)
  ],
  vysniaFloors: [
    `${A}/2bk2wxra_WhatsApp%20Image%202026-07-03%20at%2017.48.35%20%282%29.jpeg`,  // 1st floor (B01-B05)
    `${A}/x5ll069x_WhatsApp%20Image%202026-07-03%20at%2017.48.34%20%2812%29.jpeg`, // 2nd floor (B06-B10)
    `${A}/6lg4gghh_WhatsApp%20Image%202026-07-03%20at%2017.48.34%20%2811%29.jpeg`, // 3rd floor (B11-B15)
    `${A}/epyjfr2n_WhatsApp%20Image%202026-07-03%20at%2017.48.34%20%2810%29.jpeg`, // 4th floor (B16-B20)
    `${A}/0pb5ou54_WhatsApp%20Image%202026-07-03%20at%2017.48.34%20%289%29.jpeg`,  // 5th floor (B21-B25)
  ],

  // Individual apartment floor-plan sheets keyed by apartment code
  apartmentSheets: {
    "Migdolas A20": `${A}/alcxhrqi_marijampoles-m-deguciai-parko-g%20%289%29.jpg`,
    "Migdolas A1": `${A}/9fshpo17_marijampoles-m-deguciai-parko-g%20%2816%29.jpg`,
    "Migdolas A2": `${A}/igbfpkfh_marijampoles-m-deguciai-parko-g%20%2817%29.jpg`,
    "Migdolas A3": `${A}/q77qlolg_marijampoles-m-deguciai-parko-g%20%2818%29.jpg`,
    "Migdolas A4": `${A}/a41355bl_marijampoles-m-deguciai-parko-g%20%2819%29.jpg`,
    "Migdolas A5": `${A}/qznlc0f6_marijampoles-m-deguciai-parko-g%20%2822%29.jpg`,
    "Migdolas A6": `${A}/dyvg5q3j_marijampoles-m-deguciai-parko-g%20%2824%29.jpg`,
    "Migdolas A7": `${A}/ii2a1f77_0.png`,
  },

  // Per-apartment photo galleries (real renders / plans), keyed by code
  apartmentPhotos: {
    "Migdolas A1": [
      `${A}/eutjgub4_unnamed-2%20%282%29.png`,
      `${A}/gbqxhng2_unnamed-12%20%281%29.png`,
      `${A}/aq55ytey_Gemini_Generated_Image_qqnaogqqnaogqqna.webp`,
      `${A}/xrl17xd8_WhatsApp%20Image%202026-07-09%20at%2018.47.29.jpeg`,
    ],
    "Migdolas A2": [
      `${A}/zjgjarez_unnamed-6%20%281%29.png`,
      `${A}/z4icldvg_unnamed-2%20%282%29.png`,
      `${A}/l7e1sb2r_WhatsApp%20Image%202026-07-09%20at%2018.47.29.jpeg`,
      `${A}/xxlg4ty4_Gemini_Generated_Image_qqnaogqqnaogqqna.webp`,
    ],
    "Migdolas A3": [
      `${A}/o11msy6h_unnamed-13%20%281%29.png`,
      `${A}/7mrklm6g_unnamed-7%20%281%29.png`,
      `${A}/888g0gi7_WhatsApp%20Image%202026-07-09%20at%2018.47.29.jpeg`,
      `${A}/quc1u5z8_Gemini_Generated_Image_qqnaogqqnaogqqna.webp`,
    ],
    "Migdolas A4": [
      `${A}/lo3oqkrv_Dise%C3%B1o%20sin%20t%C3%ADtulo%20%282%29.webp`,
      `${A}/e43rqiqj_unnamed-13%20%281%29.png`,
      `${A}/ktj9z3zy_Gemini_Generated_Image_qqnaogqqnaogqqna.webp`,
      `${A}/au3d6son_WhatsApp%20Image%202026-07-09%20at%2018.47.29.jpeg`,
    ],
    "Migdolas A5": [
      `${A}/1szxusd6_unnamed-8%20%282%29.png`,
      `${A}/uspj0ma6_unnamed-7.png`,
      `${A}/9lzkos1r_WhatsApp%20Image%202026-07-09%20at%2018.47.29.jpeg`,
      `${A}/r5y4zp99_Gemini_Generated_Image_z1hzt4z1hzt4z1hz.webp`,
    ],
    "Migdolas A6": [
      `${A}/0gppcnlo_unnamed-9%20%281%29.png`,
      `${A}/f8cyzktl_unnamed-7%20%281%29.png`,
      `${A}/prnby2ag_WhatsApp%20Image%202026-07-09%20at%2018.47.29.jpeg`,
      `${A}/g2m1tkmv_Gemini_Generated_Image_z1hzt4z1hzt4z1hz.webp`,
    ],
    "Migdolas A7": [
      `${A}/rgc6okh1_unnamed-13%20%281%29.png`,
      `${A}/g54b2luf_unnamed-6%20%281%29.png`,
      `${A}/9rhrb3d3_unnamed-12%20%281%29.png`,
      `${A}/j0cmcw5w_Gemini_Generated_Image_z1hzt4z1hzt4z1hz.webp`,
    ],
  },
};

// Gallery: only include entries that have a real URL (filtered in Gallery page).
export const GALLERY = [
  { key: "heroNight", labelLt: "Vakarinis vaizdas", labelEn: "Night view", labelRu: "Вид ночью" },
  { key: "heroDay", labelLt: "Dieninis vaizdas", labelEn: "Day view", labelRu: "Вид днём" },
  { key: "vysniaDay", labelLt: "Vaizdas iš viršaus (diena)", labelEn: "Aerial view (day)", labelRu: "Вид сверху (день)" },
  { key: "aerial", labelLt: "Vaizdas iš viršaus", labelEn: "Aerial view", labelRu: "Вид сверху" },
  { key: "duskTwin", labelLt: "Vidinis kiemas prieblandoje", labelEn: "Courtyard at dusk", labelRu: "Двор в сумерках" },
  { key: "duskWalkway", labelLt: "Takas tarp namų", labelEn: "Walkway between buildings", labelRu: "Дорожка между домами" },
  { key: "nightFacade2", labelLt: "Fasadas vakare", labelEn: "Facade at night", labelRu: "Фасад вечером" },
  { key: "nightAerial", labelLt: "Kiemas ir aikštelė vakare", labelEn: "Courtyard & parking at night", labelRu: "Двор и парковка вечером" },
  { key: "courtyard", labelLt: "Vidinis kiemas ir žaidimų aikštelė", labelEn: "Courtyard & playground", labelRu: "Внутренний двор и детская площадка" },
];
